module.exports = __webpack_public_path__ + "static/img/环保设备出口最新.b4ced128.png";